
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#5CE8AD","fill-rule":"nonzero","d":"M14.58 1v6.42h5.67V5.58z"}}),_c('path',{attrs:{"stroke":"#000","d":"M19.64 5.21L16 1.61A2.057 2.057 0 0014.58 1H5.81a2.07 2.07 0 00-2.06 2.07v17.87A2.06 2.06 0 005.81 23h12.38a2.06 2.06 0 002.06-2.06V6.67a2.078 2.078 0 00-.61-1.46h0z"}}),_c('path',{attrs:{"stroke":"#000","d":"M19.79 7.42H15a.71.71 0 01-.71-.71V1.46h0"}}),_c('rect',{attrs:{"width":"11","height":"1.38","x":"6.5","y":"11.08","fill":"#5CE8AD","fill-rule":"nonzero","rx":".34"}}),_c('rect',{attrs:{"width":"11","height":"1.38","x":"6.5","y":"13.83","fill":"#5CE8AD","fill-rule":"nonzero","rx":".34"}}),_c('rect',{attrs:{"width":"11","height":"1.38","x":"6.5","y":"16.58","fill":"#5CE8AD","fill-rule":"nonzero","rx":".34"}})])])
          )
        }
      }
    